import { Close } from "@mui/icons-material";
import { Box, BoxProps, Button, IconButton } from "@mui/material";

type ModalControlProps = BoxProps & {
  currentView: string;
  onToggleView: () => void;
  onClose?: () => void;
  hideClose?: boolean;
  hideToggleButton?: boolean;
};

export default function ModalControl({
  currentView,
  hideClose,
  hideToggleButton,
  onToggleView,
  onClose,
  sx,
  ...restProps
}: ModalControlProps) {
  return (
    <Box
      {...restProps}
      sx={{
        position: "relative",
        display: "flex",
        justifyContent: "flex-end",
        width: "100%",
        gap: "0.62rem",
        ...sx
      }}
    >
      {!hideToggleButton && (
        <Button
          sx={{
            bgcolor: "#1D2939",
            p: "0.375rem 0.75rem",
            color: "grey.50",
            fontSize: "0.875rem",
            textTransform: "none",
            border: "1px solid #FCFCFC26",
            borderRadius: "1.5rem",
            cursor: "pointer",
            marginBottom: "1rem",
            pointerEvents: "auto"
          }}
          onClick={onToggleView}
        >
          {currentView}
        </Button>
      )}

      {!hideClose && (
        <div>
          <IconButton
            sx={{
              color: "grey.400",
              ":hover": {
                color: "red"
              }
            }}
            onClick={onClose}
          >
            <Close fontSize='large' />
          </IconButton>
        </div>
      )}
    </Box>
  );
}
